import axiosInstance from "../Interceptors/ResponseInterceptor";

// /api/stakeholder-mapping/stakeholders/add
export const createAssetBySiteId = async (id, data) => {
  return new Promise(async (resolve, reject) => {
    try {
      let postData = { SiteID: id, ...data };
      const response = await axiosInstance.post(`/api/assets/add`, postData);
      //
      resolve(response.data);
    } catch (error) {
      console.error("Error in createPassword:", error);
      reject(error);
    }
  });
};

export const deleteAssetById = async (assetId) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axiosInstance.delete(`/api/assets/${assetId}`);
      resolve(response.data);
    } catch (error) {
      console.error("Error deleting stakeholder:", error);
      reject(error);
    }
  });
};

export const getAssetStructureDesign = async () => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axiosInstance.get(`/api/structure-design/`);
      resolve(response.data);
    } catch (error) {
      console.error("Error getAssetStructureDesign:", error);
      reject(error);
    }
  });
};
